export default {
  GET_DASHBOARD_CARD_REQUEST: "GET_DASHBOARD_CARD_REQUEST",
  GET_DASHBOARD_CARD_RESPONSE: "GET_DASHBOARD_CARD_RESPONSE",
  GET_DASHBOARD_PIE_EMPLOYEE_REQUEST: "GET_DASHBOARD_PIE_EMPLOYEE_REQUEST",
  GET_DASHBOARD_PIE_EMPLOYEE_RESPONSE: "GET_DASHBOARD_PIE_EMPLOYEE_RESPONSE",
  GET_DASHBOARD_PIE_STATUS_REQUEST: "GET_DASHBOARD_PIE_STATUS_REQUEST",
  GET_DASHBOARD_PIE_STATUS_RESPONSE: "GET_DASHBOARD_PIE_STATUS_RESPONSE",
  GET_DASHBOARD_PIE_GROUPBY_PURPOSE_OF_REQUEST:
    "GET_DASHBOARD_PIE_GROUPBY_PURPOSE_OF_REQUEST",
  GET_DASHBOARD_PIE_GROUPBY_PURPOSE_OF_RESPONSE:
    "GET_DASHBOARD_PIE_GROUPBY_PURPOSE_OF_RESPONSE",
  GET_DASHBOARD_PIE_CREATED_BY_REQUEST: "GET_DASHBOARD_PIE_CREATED_BY_REQUEST",
  GET_DASHBOARD_PIE_CREATED_BY_RESPONSE:
    "GET_DASHBOARD_PIE_CREATED_BY_RESPONSE",
  GET_DASHBOARD_LINE_CHART_MONTHLY_REQUEST:
    "GET_DASHBOARD_LINE_CHART_MONTHLY_REQUEST",
  GET_DASHBOARD_LINE_CHART_MONTHLY_RESPONSE:
    "GET_DASHBOARD_LINE_CHART_MONTHLY_RESPONSE",
  GET_DASHBOARD_LINE_CHART_YEARLY_REQUEST:
    "GET_DASHBOARD_LINE_CHART_YEARLY_REQUEST",
  GET_DASHBOARD_LINE_CHART_YEARLY_RESPONSE:
    "GET_DASHBOARD_LINE_CHART_YEARLY_RESPONSE",
};
